module.exports = "/static/assets/dceb93b37e4cf529dd81ab807ebdbd9e.svg";